const toCurrency = (value) => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

// Formata o preço de um plano para exibição.
//
// `cycle` (default 'MONTHLY'): quando 'YEARLY' e o plano tem preço anual
// cadastrado, o valor principal passa a ser o anual e o rótulo secundário
// mostra o equivalente mensal. Sem preço anual (opcional, ver migration 034),
// ou no ciclo mensal, mantém o mensal como principal e o anual como "ou ...".
// billingLabel vem null quando não há o que mostrar na 2ª linha — quem
// consome decide se esconde (v-if).
export function formatPlanPrice(plan, cycle = 'MONTHLY') {
  const hasYearly = plan?.price_yearly != null

  if (cycle === 'YEARLY' && hasYearly) {
    return {
      priceLabel: `${toCurrency(plan.price_yearly)}/ano`,
      billingLabel: `equivale a ${toCurrency(plan.price_yearly / 12)}/mês`,
    }
  }

  return {
    priceLabel: `${toCurrency(plan?.price_monthly)}/mês`,
    billingLabel: hasYearly ? `ou ${toCurrency(plan.price_yearly)}/ano` : null,
  }
}
